import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";


const adminDashBoardApi = createApi( {
    reducerPath: 'adminDashBoardApi',
    baseQuery: defautBaseQuery,
    endpoints: ( builder ) => ( {
        getAdminDashboardDetail: builder.query( {
            query: () => ( {
                url: encryptQueryString( `/Dashboard/GetMembershipDashboardSummary` ),
                method: 'GET',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        getReasonForJoiningNew: builder.query( {
            query: () => ( {
                url: encryptQueryString( `/Dashboard/GetReasonOfJoiningForNewApplication` ),
                method: 'GET',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        getReasonForJoiningRenewal: builder.query( {
            query: () => ( {
                url: encryptQueryString( `/Dashboard/GetReasonOfJoiningForRenewalApplication` ),
                method: 'GET',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        getRenewalAnalyticsOverviewForReport: builder.query( {
            query: () => ( {
                url: encryptQueryString( `/Dashboard/GetRenewalAnalyticsOverviewForReport` ),
                method: 'GET',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        iframeUrl: builder.mutation( {
            query: ( details ) => ( {
                url: '/Metabase/IframeUrl',
                method: 'POST',
                body: transformRequest( details )
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
    } ),
} )

export const {
    useLazyGetAdminDashboardDetailQuery,
    useIframeUrlMutation,
    useLazyGetReasonForJoiningNewQuery,
    useLazyGetReasonForJoiningRenewalQuery,
    useLazyGetRenewalAnalyticsOverviewForReportQuery
} = adminDashBoardApi;

export default adminDashBoardApi;